import { render, staticRenderFns } from "./JoinTeam.vue?vue&type=template&id=c04d2598&scoped=true"
import script from "./JoinTeam.vue?vue&type=script&lang=js"
export * from "./JoinTeam.vue?vue&type=script&lang=js"
import style0 from "./JoinTeam.vue?vue&type=style&index=0&id=c04d2598&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04d2598",
  null
  
)

export default component.exports